import { PreviewerField } from "..";

export default function getValueIndex(e: PreviewerField) {
  if (e.field.multiple == true) {
    return Number(e.preId.split('_')[1]);
  }
}